// extracted by mini-css-extract-plugin
export default {"fontBlue":"DashboardPersonalInformation_fontBlue__SMXKd","loading":"DashboardPersonalInformation_loading__GA+gr","small":"DashboardPersonalInformation_small__kALkx"};